module.exports = __webpack_public_path__ + "static/media/clover-go-payments-device-easy-card-reader-setup.0644f26b.png";